<p-toast position="top-right" [life]="messagelife" styleClass="app-toast">
  <ng-template let-message pTemplate="message">
    <div class="toast-card" [ngClass]="'toast-' + (message.severity || 'info')">
      <div class="toast-icon-wrap" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
          <use [attr.xlink:href]="'assets/images/icon-library.svg#' + message.icon"></use>
        </svg>
      </div>
      <div class="toast-content">
        <div class="toast-title">{{ message.summary }}</div>
        <div class="toast-text">{{ message.detail }}</div>
      </div>
      <button
        type="button"
        class="toast-close"
        aria-label="Close"
        (click)="dismiss()"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="toast-progress" aria-hidden="true"></div>
    </div>
  </ng-template>
</p-toast>
